import { RecoilRoot } from 'recoil'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import './App.scss'
import ErrorFallbackPage from './pages/ErrorFallbackPage'
import MainPage from './pages/MainPage'
import { DoActivityPage } from "./pages/DoActivityPage"
import InvitePage from './pages/InvitePage'
import { useUser } from './atoms'
import HomePage from './pages/HomePage'
import { DoActivityAreaPage } from './pages/DoActivityAreaPage'
import { DoActivityAreaLevelPage } from './pages/DoActivityAreaLevelPage'
import { Box } from '@mui/material'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { QueryClientProvider, QueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'
import './framework/i18n/i18n';
import 'moment/locale/it';
import UserSettingPage from './pages/UserSettingPage'
import { LoggerServiceProvider } from './framework/logger'
import NewsEditPage from './pages/NewsEditPage'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import itLocale from "date-fns/locale/it";
import ServiceEditPage from './pages/ServiceEditPage'
import TestSearchPage from './components/SearchWithNewsSection'
import { User } from './models/User'
import ConsentMarketingPage from './pages/ConsentMarketingPage'
import CarouselPage from './pages/CarouselPage'
import CarouselEditPage from './pages/CarouselEditPage'
import ServiceDescriptorSearch from './pages/ServiceDescriptorSearch'
import ServiceDescriptorEdit from './pages/ServiceDescriptorEdit'

import { ThemeProvider, createTheme } from '@mui/material/styles'
import HelpPage from './pages/HelpPage'

const queryClient = new QueryClient()
const theme = createTheme({
  typography: {
    fontFamily: [
      '"Open Sans"',
        //'"Be Vietnam"',
      'sans-serif'
    ].join(','),
    //fontSize: 14,
  },
  palette: {
    primary: {
      light: '#319ED8',
      // main: '#0B2E4F',
      main: '#006f98',
      dark: '#165874'
    },
    secondary: {
      light: '#3C5872',
      //main: '#006F98',  //#0B2E4F
      main: '#0B2E4F',
      //main: '#1d2d3d',
      //dark: '#165874'
      dark: '#1d2d3d'
    },
  },
})

function App() {
  const { t } = useTranslation()

  return (
    <ThemeProvider theme={theme}>
      {/* <QueryClientProvider client={queryClient}> */}
        <RecoilRoot>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={itLocale}>
            <LoggerServiceProvider>
              <Router basename={`${process.env.PUBLIC_URL}`}>
                <ErrorBoundary FallbackComponent={ErrorFallbackPage}>
                  <Routes>
                    <Route element={<MainContainer />}>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/help" element={<HelpPage />} />
                      <Route path="do" element={<DoActivityPage />}>
                        <Route path=":area" element={<DoActivityAreaPage />}>
                          <Route path=":level" element={<DoActivityAreaLevelPage />} />
                        </Route>
                        <Route index element={<Box sx={{ padding: "1rem" }}><p>{t('Seleziona un\'area')}</p></Box>} />
                      </Route>
                      <Route path="setting/:username" element={<UserSettingPage />} />
                      <Route path="ednews/:id/:type" element={<NewsEditPage />} />
                      <Route path="service/:id" element={<ServiceEditPage />} />
                      <Route path="test/search" element={<TestSearchPage placeholer='Cerca applicazioni e/o news...' />} />
                      <Route path="adm/carousel" element={<CarouselPage />} />
                      <Route path="adm/carousel/:id" element={<CarouselEditPage />} />
                      <Route path="adm/servicedescriptor" element={<ServiceDescriptorSearch />} />
                      <Route path="adm/servicedescriptor/:id" element={<ServiceDescriptorEdit />} />
                    </Route>
                  </Routes>
                </ErrorBoundary>
              </Router>
            </LoggerServiceProvider>
          </LocalizationProvider>
        </RecoilRoot>
      {/* </QueryClientProvider> */}
    </ThemeProvider>
  )
}

export default App

const MainContainer: React.FC = () => {
  const user = useUser()

  return (
    <>
      {user.isAuthenticated
        ? <MainPageOrConsent user={user} />
        : <InvitePage />}
    </>
  )
}

const MainPageOrConsent = ({ user }: { user: User }) => {

  // console.log('user.context?.consentiMarketing', user.context?.consentiMarketing)
  return (
    //MarketingConsentPage la mostro solo se la provincia vuole

    <>
      {(user.setting && user.setting.marketingConsent === null && user.context?.consentiMarketing === true)
        ? <ConsentMarketingPage />
        : <MainPage />
      }
    </>
  )
}
